import * as React from "react";
import "sanitize.css";
import { ThemeProvider } from "styled-components";
import { DefaultMetaTag } from "faqSrc/components/modules/metaTag";

const theme = {
  supportDarkMode: true,
};

export default function AppLayout({
  children,
}: {
  children: React.ReactElement;
}) {
  return (
    <ThemeProvider theme={theme}>
      {/* Refer https://github.com/catnose99/next-head-seo#default-seo-settings */}
      <DefaultMetaTag />
      {children}
    </ThemeProvider>
  );
}
